import { location, reactive } from 'cdui-js'
import { goBackByBrowser } from '../../../../lib/browser'
import { initRNBridge, postToApp, registerRNHandler } from '../../../../lib/rnBridge'

export const addAccState = reactive({
  busId: '',
  step: 1,
  /** 签名页展示用姓名（来自 userBase.fullName） */
  fullName: '',
  /** SelectTypes 选中的账户类型，签名确认时再 saveApply */
  securitiesAccountType: '',
  fundAccountType: '',
  /** 交易权限：是否需要衍生品交易权限（与开户一致，字典勾选后提交） */
  needDerivativeTradePermission: false,
  /** 大陆用户加开虚拟账户：同页进入境外身份补充，避免 routeTo 懒加载白屏 */
  virtualFlow: false,
  /** BACK 续办：进入 virtualFlow 时跳过 reset，保留 hydrate 结果 */
  virtualResume: false,
  /** BACK 非虚拟续办：列表直跳 Risk，上一步应回列表而非选类型 */
  riskResumeFromList: false,
})

/** App 深链直进选类型（无已退回单，不经过列表） */
const isDeepLinkSelectTypes = () =>
  location.query.step === 'SelectTypes' || location.query.step === '2'

const exitAddAccount = () => {
  if ((window as any).ReactNativeWebView) {
    postToApp({ type: 'WEB_TO_APP_GoBack' })
    return
  }
  goBackByBrowser()
}

export const lastProgress = () => {
  if (addAccState.virtualFlow) {
    addAccState.virtualFlow = false
    return
  }
  // BACK 续办：Risk → 列表（跳过选类型）
  if (addAccState.step === 3 && addAccState.riskResumeFromList) {
    addAccState.riskResumeFromList = false
    addAccState.step = 1
    return
  }
  // 深链 ?step=SelectTypes|2：选类型页返回直接退出，不回 ApplyList
  if (addAccState.step === 2 && isDeepLinkSelectTypes()) {
    exitAddAccount()
    return
  }
  if (addAccState.step > 1) {
    addAccState.step--
    return
  }
  exitAddAccount()
}

export const nextProgress = () => {
  addAccState.step++
}

let addAccountBackUnsub: (() => void) | null = null

/** App 顶栏返回：注册一次 APP_TO_WEB_GoBack → lastProgress */
export function ensureAddAccountAppBackHandler() {
  initRNBridge()
  if (addAccountBackUnsub) return
  addAccountBackUnsub = registerRNHandler((msg) => {
    if (msg.type === 'APP_TO_WEB_GoBack') {
      lastProgress()
    }
  })
}

// 加开账户功能：
// 修改旧逻辑：开户方式(网上转账开户/预约开户)由applyType改成applyMethod
// 开户类型：applyType：NEW_APPLY 新开户 / ADD_ACCOUNT 新增账户
// 接口：
// 1. 查询申请列表：/user/account/apply/getListByUserId?applyType=ADD_ACCOUNT
// 2. 获取原来的证券账户类型和基金账号类型：/user/account/account/getByUserId
// 3. 保存加开账户申请：/user/account/apply/save，传：applyType,securitiesAccountType,fundAccountType
// 4. 签名页上传签名图（useFor=add_account_pdf_sign_completed）并提交申请：/user/account/apply/submit
